import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

// ============================================
// IMPORT YOUR 20 RAILWAY TUNNEL IMAGES HERE ⬇️
// ============================================
import tunnel1 from '../assets/images/tunnel1.jpg';
import tunnel2 from '../assets/images/tunnel2.jpg';
import tunnel3 from '../assets/images/tunnel3.jpg';
import tunnel4 from '../assets/images/tunnel4.jpg';
import tunnel5 from '../assets/images/tunnel5.jpg';
import tunnel6 from '../assets/images/tunnel6.jpg';
import tunnel7 from '../assets/images/tunnel7.jpg';
import tunnel8 from '../assets/images/tunnel8.jpg';
import tunnel9 from '../assets/images/tunnel9.jpg';
import tunnel10 from '../assets/images/tunnel10.jpg';
import tunnel11 from '../assets/images/tunnel11.jpg';
import tunnel12 from '../assets/images/tunnel12.jpg';
import tunnel13 from '../assets/images/tunnel13.jpg';
import tunnel14 from '../assets/images/tunnel14.jpg';
import tunnel15 from '../assets/images/tunnel15.jpg';
import tunnel16 from '../assets/images/tunnel16.jpg';
import tunnel17 from '../assets/images/tunnel17.jpg';
import tunnel18 from '../assets/images/tunnel18.jpg';
import tunnel19 from '../assets/images/tunnel19.jpg';
import tunnel20 from '../assets/images/tunnel20.jpg';

import '../styles/Pages.css';

const RailwayTunnel = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // All 20 images array
  const images = [
    tunnel1, tunnel2, tunnel3, tunnel4, tunnel5,
    tunnel6, tunnel7, tunnel8, tunnel9, tunnel10,
    tunnel11, tunnel12, tunnel13, tunnel14, tunnel15,
    tunnel16, tunnel17, tunnel18, tunnel19, tunnel20
  ];

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Railway Tunnel Roof</h1>
            <p>Advanced Infrastructure Solutions</p>
          </div>
        </div>
      </section>

      {/* IMAGES SECTION - 20 IMAGES IN 3-COLUMN GRID */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          {/* HEADING */}
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '50px', 
            textAlign: 'center' 
          }}>
            Railway Tunnel Projects
          </h2>

          {/* IMAGES GRID - 3 COLUMNS */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '30px',
            marginTop: '40px'
          }}>
            {images.map((img, index) => (
              <div 
                key={index}
                style={{ 
                  overflow: 'hidden', 
                  borderRadius: '8px', 
                  boxShadow: '0 4px 12px rgba(0,0,0,0.12)', 
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  aspectRatio: '1'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
                }}
              >
                <img 
                  src={img} 
                  alt={`Railway Tunnel ${index + 1}`}
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    display: 'block',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEXT SECTION AT BOTTOM */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '30px', 
            textAlign: 'center' 
          }}>
            Our Tunnelling Expertise
          </h2>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8', 
            marginBottom: '20px',
            textAlign: 'justify'
          }}>
            Max Infra's expertise lies in Tunnelling. So far we have successfully completed two Railway Tunnels in challenging locations, Shear Zones and difficult terrains. At present we are executing six Railway Tunnels in different locations.
          </p>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8',
            textAlign: 'justify'
          }}>
            Our experienced team, advanced machinery, and proven track record in tunnelling demonstrate our commitment to delivering world-class infrastructure solutions even in the most challenging geological conditions.
          </p>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE DESIGN */}
      <style>{`
        @media (max-width: 1024px) {
          .tunnel-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 25px !important;
          }
        }
        @media (max-width: 768px) {
          .tunnel-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default RailwayTunnel;